<template>
  <div class="table_wrap member">
    <span class="total_length">총 {{ paginationData.total }}명 </span>
    <el-table class="list-table" header-cell-class-name="list-header"
              style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              :data="memberData"
    >
      <el-table-column
              class="table_no"
              type="index"
              label="No"
              width="90"
              class-name="num text-center"
              :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
              label="회원유형" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnMemberType(scope.row.mb_premium)}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="아이디" width="" class-name="text-center" prop="mb_id"></el-table-column>
      <el-table-column label="닉네임" width="" class-name="text-center" prop="mb_nick"></el-table-column>
      <el-table-column label="이름" width="" class-name="text-center" prop="mb_name"></el-table-column>
      <el-table-column label="신청일" width="" class-name="text-center" prop="created_at"></el-table-column>
      <el-table-column
              label="회원상세" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info ">
<!--            <div class="row-info pointer"  @click="moveDetail(scope.row.mb_no)">
              [상세]
            </div>-->
              <el-button class="com_btn"  @click="moveDetail(scope.row.mb_no)">
                  상세
              </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="신청정보" width="" class-name="text-center">
        <template slot-scope="scope">
<!--          <div class="row-info pointer"  @click="moveApproveInfo(scope.row.c_idx)">
            [신청정보]
          </div>-->
            <el-button class="com_btn"  @click="moveApproveInfo(scope.row.c_idx)">
                신청정보
            </el-button>
        </template>
      </el-table-column>
      <el-table-column
              label="옵션" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <div v-if="scope.row.c_status == 0">
              <el-button class="com_search" @click="runAllow('allow', scope.row.c_idx)">
                승인
              </el-button>
              <el-button class="reg_btn_out" @click="runAllow('refuse', scope.row.c_idx)">
                거절
              </el-button>
            </div>
            <div v-else>{{returnCuratorStatus(scope.row.c_status)}}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import dateMixins from "@/mixins/dateMixins";
  import util from "@/mixins/util";
  import {memberType,curatorStatus} from "@/service/memberService";
  import alertMixins from "@/mixins/alertMixins";
export default {
  name: "MemberListCuratorLayout",
  mixins: [alertMixins],
  components: {
  },
  inject: ['changeAllow'],
  provide() {
    return{
    }
  },
  props: {
    memberData: {default: () => []},
    paginationData: {default: {total: 0}},
  },
  data() {
    return{
      idx: 1
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    /*goDetail(idx) {
      this.$router.push(`/member/${idx}`);
    },
    goUpdate(idx){
      this.$router.push(`/member/curator/approve/apply/${idx}`);
    },*/
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnMemberType(type) {
      if(util.isEmpty(memberType[type])) {
        return '';
      }
      return memberType[type].name;
    },
    returnCuratorStatus(status) {
      if(util.isEmpty(curatorStatus[status])) {
        return '';
      }
      return curatorStatus[status].name;
    },
    runAllow(type, key) {
      let text = type === 'allow' ? '정말 승인하시겠습니까?' : '정말 거절하시겠습니까?';
      this.createConfirm({
        content: text,
        confirm: () => {
          this.changeAllow(type, key)
        }
      })

    },
    moveDetail(idx) {
      this.$router.push(`/member/detail/${idx}`)
    },
    moveApproveInfo(idx){
      this.$router.push(`${this.$route.path}/apply/${idx}`)
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
